var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHardButtonsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.368 1.9895h-7.7369c-1.0377 0-1.879 0.84123-1.879 1.879v6.2632c0 1.0377 0.84123 1.8789 1.879 1.8789h7.7369c1.0377 0 1.8789-0.8412 1.8789-1.8789v-6.2632c0-1.0377-0.8412-1.879-1.8789-1.879zm-7.7369-1.2526c-1.7295 0-3.1316 1.4021-3.1316 3.1316v6.2632c0 1.7295 1.4021 3.1315 3.1316 3.1315h7.7369c1.7295 0 3.1315-1.402 3.1315-3.1315v-6.2632c0-1.7295-1.402-3.1316-3.1315-3.1316z",
    clipRule: "evenodd",
    fill: "#272727",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.254 7c0 1.5569-1.2329 2.819-2.7537 2.819-1.5208 0-2.7537-1.2621-2.7537-2.819 0-1.5569 1.2329-2.819 2.7537-2.819 1.5208 0 2.7537 1.2621 2.7537 2.819z",
    fill: "#272727",
    strokeWidth: 1.8906
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardButtonsIcon);
export default __webpack_public_path__ + "static/media/hard-buttons-icon.147b9af712cfd124b10d107f176feb62.svg";
export { ForwardRef as ReactComponent };